import * as React from "react";

import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, ComponentProps<"textarea">>(({ className, ...props }, ref) => {
    return (
        <textarea
            ref={ref}
            data-slot="textarea"
            className={cn(
                "setu:!border-input setu:placeholder:text-muted-foreground setu:focus-visible:!border-ring setu:focus-visible:ring-ring/50 setu:aria-invalid:ring-destructive/20 dark:setu:aria-invalid:ring-destructive/40 setu:aria-invalid:!border-destructive dark:setu:bg-input/30 setu:flex setu:field-sizing-content setu:min-h-16 setu:w-full setu:rounded-md setu:!border setu:bg-transparent setu:px-3 setu:py-2 setu:text-base setu:shadow-xs setu:transition-[color,box-shadow] setu:outline-none setu:focus-visible:ring-[3px] setu:disabled:cursor-not-allowed setu:disabled:opacity-50 md:setu:text-sm",
                className
            )}
            {...props}
        />
    );
});
Textarea.displayName = "Textarea";

export { Textarea };
